import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { GET_LIMITS, GetLimitsAction, GetLimitsSuccessAction } from 'app/shared/limits/limits.actions';
import { LimitsService } from 'app/shared/limits/limits.service';
import { BOOTSTRAP_COMPLETE } from 'app/bootstrap/bootstrap.actions';

@Injectable()
export class LimitsEffects {
  @Effect()
  fetchLimits$ = this.actions$.pipe(
    ofType(GET_LIMITS),
    switchMap(() => this.limitsService.fetchLimits().pipe(map(limits => new GetLimitsSuccessAction(limits))))
  );

  @Effect() onBootstrapComplete$ = this.actions$.pipe(ofType(BOOTSTRAP_COMPLETE), map(() => new GetLimitsAction()));

  constructor(private actions$: Actions, private limitsService: LimitsService) {}
}
